<template>
  <div class="tv-content">
    <div v-if="!isConnected"></div>
    <slot v-else></slot>
  </div>
</template>

<script>
import config from '@/config';
import { useSignalR } from '@dreamonkey/vue-signalr';

export default {
  name: 'TvBase',

  props: {
    storageKey: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isConnected: false,
    };
  },

  created() {
    this.$socket = useSignalR();

    if (this.$route.query.id) {
      localStorage.setItem(this.storageKey, this.$route.query.id);
      this.$router.push({ queyr: {} });
    }

    this.initSocket();
    this.$socket.on('reconect', this.initSocket);
  },

  methods: {
    async initSocket() {
      const id = localStorage.getItem(this.storageKey);

      const regex1 = RegExp(/^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i);

      if (!id || !regex1.test(id)) {
        return window.location.replace(`${config.NXTROOM_URL}/tv${this.storageKey.slice(2, 3)}`);
      }

      return this.connect(id);
    },

    async connect(id) {
      this.isConnected = true;
      try {
        await this.$socket.invoke('connect', { id });
      } catch {
        localStorage.removeItem(this.storageKey);
        this.isConnected = false;
        window.location.replace(`${config.NXTROOM_URL}/tv${this.storageKey.slice(2, 3)}`);
      }
    },
  },

  sockets: {
    selectLang(lang) {
      this.$store.dispatch('changeLanguage', lang);
      this.$i18n.locale = lang;
    },

    connected({ id }) {
      this.connect(id);
      localStorage.setItem(this.storageKey, id);
    },

    application_details({ application, environment }) {
      if (`${application.urls[environment]}tv${this.storageKey.slice(2, 3)}` === window.location.href) {
        return;
      }
      const deviceId = localStorage.getItem(this.storageKey);
      window.location.replace(`${application.urls[environment]}tv${this.storageKey.slice(2, 3)}?id=${deviceId}`);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.tv-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background: colors.$dark-color;
}
</style>
